import FollowUp from './FollowUp'

export default FollowUp
